/* 🤖 this file was generated by svg-to-ts */
export const matIcon60FpsSelect: {
  name: '60-fps-select';
  data: string;
} = {
  name: '60-fps-select',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 6v6h-3V6h3zm0-2h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2V4H6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H6V6h5zm-2 4v2H6v-2h3zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"/></svg>`
};
